import { render } from "./DJfreeze.vue?vue&type=template&id=eb3fff76&scoped=true"
import script from "./DJfreeze.vue?vue&type=script&lang=js"
export * from "./DJfreeze.vue?vue&type=script&lang=js"

import "./DJfreeze.vue?vue&type=style&index=0&id=eb3fff76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eb3fff76"

export default script